import Markdown from "markdown-to-jsx";
import React, { useState } from "react";
import { Link, withRouter } from "react-router-dom";
import styled from "styled-components";
import BarLoader from "../../animations/BarLoader";
import QueryLoading from "../../animations/QueryLoading";
import InnerContentWrapper from "../../styles/InnerContentWrapper";
import ProgramNavigation from "../ProgramNavigation";
import BioBox from "../sidebar/BioBox";
import ProgramSidebar from "../sidebar/ProgramSidebar";
import LessonCompleteButton from "./LessonCompleteButton";

const StyledProgramPost = styled.div`
  .thumbnail {
    width: 100%;
    position: absolute;
    top: 0;
    z-index: 1;
    /* padding: 56.25% 0 0 0; */
  }
  .postGrid {
    display: grid;
    grid-template-columns: auto 340px;
    grid-column-gap: 2rem;
    padding: 2rem 0 0;
    @media (max-width: 1060px) {
      display: block;
      .column1 {
        margin-bottom: 2rem;
      }
    }
  }
  .column1 {
    box-shadow: ${(props) => props.theme.boxShadow};
    .postTitle {
      font-size: 2rem;
      margin-bottom: 16px;
      @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
        font-size: 28px;
      }
    }
    .sectionTitle {
      font-size: 20px;
      margin: 16px 0 24px;
      color: ${(props) => props.theme.primaryBlue};
    }
    .postBody {
      p {
        word-wrap: break-word;
      }
    }
  }
  .downloadsBox {
    box-shadow: ${(props) => props.theme.boxShadow};
    .downloadsHeading {
      margin-bottom: 2rem;
    }
    .download {
      font-family: "Roboto", sans-serif;
      color: ${(props) => props.theme.primaryBlue};
      text-decoration: underline;
    }
  }
  .placeholder {
    justify-content: center;
    pointer-events: none;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    background: black;
    z-index: 2;
    opacity: ${(props) => (props.imageLoaded ? 0 : 1)};
    transition: opacity 200ms ease-out;
    /* padding: 56.25% 0 0 0; */
  }
  .iframeWrapper {
    position: relative;
    padding: 56.25% 0 0 0;
    iframe {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
    }
  }
`;

const ProgramPost = ({
  match,
  sectionName,
  sectionId,
  programMainCategory,
  courseId,
  courseName,
  completedTokens,
  getCompletedTokens,
}) => {
  const [imageLoaded, setimageLoaded] = useState(false);

  const [loading, setloading] = useState(false);

  let programPost;
  for (const subCategory of programMainCategory.subCategories) {
    for (const post of subCategory.programPosts) {
      if (post.programPostId === match.params.postId) {
        programPost = post;
        break;
      }
    }
  }
  let isCompleted = completedTokens.indexOf(programPost.programPostId) > -1;

  const startLoading = () => {
    setloading(true);
  };

  if (loading) {
    return <QueryLoading />;
  }

  return (
    <InnerContentWrapper>
      <ProgramNavigation>
        <span>
          <Link to={`/`}>My Courses</Link>
        </span>{" "}
        /{" "}
        <span>
          <Link to={`/course/${courseId}`}>{courseName}</Link>
        </span>{" "}
        /{" "}
        <span>
          <Link
            to={`/course/${courseId}/section/${programMainCategory.mainCategoryId}`}
          >
            {programMainCategory.mainCategoryTitle}
          </Link>
        </span>{" "}
        / <span>{programPost.programPostTitle}</span>
      </ProgramNavigation>
      <StyledProgramPost imageLoaded={imageLoaded}>
        <div className="iframeWrapper">
          {programPost.programPostVideo ? (
            <iframe
              src={programPost.programPostVideo}
              title={programPost.programPostId}
              frameBorder="0"
              allow="autoplay; fullscreen"
              allowFullScreen
              onLoad={() => setimageLoaded(true)}
            ></iframe>
          ) : (
            <img
              src={`${programPost.thumbnail}?fm=jpg&fl=progressive&w=1200`}
              className="thumbnail"
              alt=""
              onLoad={() => setimageLoaded(true)}
            />
          )}
          <div className="placeholder">
            <BarLoader />
          </div>
        </div>
        <div className="postGrid">
          <div>
            <div className="column1 whiteBG innerPadding">
              <h1 className="postTitle">{programPost.programPostTitle}</h1>
              <Link to={`/?section=${sectionId}`}>
                <h2 className="sectionTitle">{sectionName}</h2>
              </Link>
              {programPost.programPostText ? (
                <div className="standardCopy postBody">
                  <Markdown>{programPost.programPostText}</Markdown>
                </div>
              ) : null}
              <LessonCompleteButton
                isCompleted={isCompleted}
                programPostId={programPost.programPostId}
                contentfulCourseId={courseId}
                startLoading={startLoading}
                getCompletedTokens={getCompletedTokens}
                route={`/course/${courseId}/section/${programMainCategory.mainCategoryId}`}
              />
            </div>
          </div>

          <ProgramSidebar>
            {programPost.downloads.length > 0 ? (
              <div className="downloadsBox whiteBG innerPadding">
                <div className="downloadsHeading">Downloads</div>
                {programPost.downloads.map((download) => {
                  return (
                    <a
                      href={download.downloadableFile}
                      target="blank"
                      download
                      key={download.title}
                      className="download"
                    >
                      {download.title}
                    </a>
                  );
                })}
              </div>
            ) : null}
            <BioBox />
          </ProgramSidebar>
        </div>
      </StyledProgramPost>
    </InnerContentWrapper>
  );
};

export default withRouter(ProgramPost);
